/*-----------------------------------------------------------------
- Components translations
-----------------------------------------------------------------*/

export default {
    
    dropzone: {
        
        drag: {
            single  : 'Drop file here!',
            multiple: 'Drop files here!',
        },
        
        button: {
            small   : 'Select file',
            single  : 'Or select your file',
            multiple: 'Or select your files',
        },
        
        add: 'Add file',
        
    },
    
    select: {
        placeholder      : 'Select from the options.',
        placeholderSearch: 'Select or search.',
    },
    
    images: {
        empty: 'No attachments found!',
    },
    
};
